import { useAuth } from '../../../contexts/AuthContext';
import { useLayout } from '../../../contexts/LayoutContext';
import { isAdmin } from '../../../services/auth';

interface SidebarProps {
  activeMenu: string;
  onMenuChange?: (menu: string) => void;
}

export default function Sidebar({ activeMenu, onMenuChange = () => {} }: SidebarProps) {
  const { user } = useAuth();
  const { sidebarOpen, closeSidebar } = useLayout();
  const isAdminUser = isAdmin(user);

  const userMenuItems = [
    { id: '首页', label: '首页', icon: 'ri-home-line', path: '/' },
    { id: '视频生成', label: '视频生成', icon: 'ri-video-line', path: '/sora2-video' },
    { id: '首尾帧视频', label: '首尾帧视频', icon: 'ri-film-line', path: '/veo31-video' },
    { id: '故事板', label: '故事板', icon: 'ri-layout-grid-line', path: '/sora2-storyboard' },
    { id: '爆款视频反推', label: '爆款视频反推', icon: 'ri-loop-left-line', path: '/viral-video-reverse' },
    { id: '一键出大片', label: '一键出大片', icon: 'ri-movie-2-line', path: '/one-click-video' },
    { id: '虚拟模特库', label: '虚拟模特库', icon: 'ri-user-star-line', path: '/virtual-models' },
    { id: 'AI生图', label: '高精度文生图', icon: 'ri-image-add-line', path: '/ai-image' },
    { id: '智能风格转换', label: '智能风格转换', icon: 'ri-palette-line', path: '/style-transfer' },
    { id: 'AI对话助手', label: 'AI 对话助手', icon: 'ri-customer-service-2-line', path: '/ai-chat' },
    { id: '积分充值', label: '积分充值', icon: 'ri-coin-line', path: '/recharge' },
    { id: '素材空间', label: '素材空间', icon: 'ri-folder-image-line', path: '/materials' },
    { id: '历史记录', label: '历史记录', icon: 'ri-history-line', path: '/history' }
  ];

  const adminMenuItems = [
    { id: '用户管理', label: '用户管理', icon: 'ri-user-settings-line', path: '/admin/users' },
    { id: '模型管理', label: '模型管理', icon: 'ri-settings-2-line', path: '/admin/models' },
    { id: '数据库管理', label: '数据库管理', icon: 'ri-database-line', path: '/database-manager' }
  ];

  const menuItems = isAdminUser ? adminMenuItems : userMenuItems;

  const handleMenuClick = (item: (typeof menuItems)[0]) => {
    onMenuChange(item.id);
    closeSidebar();
    if (item.path && window.REACT_APP_NAVIGATE) {
      setTimeout(() => window.REACT_APP_NAVIGATE(item.path), 0);
    }
  };

  const navContent = (
    <>
      <div className="p-4 lg:p-6 border-b border-gray-800 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/0049b3e4-56a1-4c9e-b4c8-8d65e68390fd.png"
            alt="Logo"
            className="h-8 w-auto"
          />
          <span className="text-sm text-gray-400">Pro</span>
        </div>
        <button
          type="button"
          onClick={closeSidebar}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-800 cursor-pointer"
          aria-label="关闭菜单"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
      </div>
      <nav className="flex-1 py-4 overflow-y-auto">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleMenuClick(item)}
            className={`w-full px-6 py-3.5 min-h-[44px] flex items-center gap-3 text-sm transition-all cursor-pointer touch-manipulation ${
              activeMenu === item.id
                ? 'bg-blue-600/10 text-blue-400 border-r-2 border-blue-600'
                : 'text-gray-400 hover:text-gray-300 hover:bg-[#1a1a1a]'
            }`}
          >
            <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center shrink-0`}></i>
            <span className="whitespace-nowrap">{item.label}</span>
          </button>
        ))}
      </nav>
    </>
  );

  return (
    <>
      {/* 桌面端：固定侧栏 */}
      <aside className="hidden lg:flex w-64 min-h-full bg-[#0a0a0a] border-r border-gray-800 flex-col shrink-0">
        {navContent}
      </aside>

      {/* 移动端：抽屉 + 遮罩 */}
      {sidebarOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/60 z-40 lg:hidden"
            onClick={closeSidebar}
            aria-hidden
          />
          <aside className="fixed inset-y-0 left-0 w-[280px] max-w-[85vw] bg-[#0a0a0a] border-r border-gray-800 flex flex-col z-50 lg:hidden shadow-xl">
            {navContent}
          </aside>
        </>
      )}
    </>
  );
}
